import { PageWrapper } from './PageWrapper';
import { PasswordReset } from './PasswordReset/PasswordReset';
import { TwoFactorAuthentification } from './TwoFactorAuthentification';
import { UserInfo } from './UserInfo';

export function Page() {
  return (
    <PageWrapper>
      <UserInfo />
      <PasswordReset />
      <TwoFactorAuthentification />
    </PageWrapper>
  );
}
